import { BaseModel } from 'projects/core/src/lib/models/base.model';
import { BusinessunitModel } from 'projects/core/src/lib/models/businessunit.model';
import { Deserializable } from 'projects/core/src/lib/models/deserializable';
import { RecommendationModel } from 'projects/core/src/lib/models/recommendation.model';
import { TemplateModel } from 'projects/core/src/lib/models/template.model';

export class MessageorderOptionsModel extends BaseModel implements Deserializable {

  templates: Array<TemplateModel>;
  businessunits: Array<BusinessunitModel>;
  recommendations: Array<RecommendationModel>;
  roles: Array<string>;

  deserialize(input: any): this {
    Object.assign(this, input);
    // templates
    let templates = null;
    if (this.templates !== null && this.templates !== undefined) {
      templates = [];
      this.templates.forEach((template: TemplateModel) => {
        templates.push(new TemplateModel().deserialize(template));
      });
    }
    this.templates = templates;
    // businessunits
    let businessunits = null;
    if (this.businessunits !== null && this.businessunits !== undefined) {
      businessunits = [];
      this.businessunits.forEach((businessunit: BusinessunitModel) => {
        businessunits.push(new BusinessunitModel().deserialize(businessunit));
      });
    }
    this.businessunits = businessunits;
    // recommendations
    let recommendations = null;
    if (this.recommendations !== null && this.recommendations !== undefined) {
      recommendations = [];
      this.recommendations.forEach((recommendation: RecommendationModel) => {
        recommendations.push(new RecommendationModel().deserialize(recommendation));
      });
    }
    this.recommendations = recommendations;
    return this;
  }
}
